import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';

import WarRoom from './pages/WarRoom';
import Drafting from './pages/Drafting';
import Battle from './pages/Battle';
import Campaigns from './pages/Campaigns';
import Lobby from './pages/Lobby';
import Court from './pages/Court';
import Auth from './pages/Auth';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import ComingSoon from './pages/ComingSoon';
import Rulebook from './pages/Rulebook';
import History from './pages/History';
import ReplayBattle from './pages/ReplayBattle';
import QuickPlay from './pages/QuickPlay';
import { Barracks } from './pages/Barracks';
import LinkAccount from './pages/LinkAccount';

import Landing from './pages/Landing';
import WarSimulation from './pages/WarSimulation';
import { TudorHeader } from './components/TudorHeader';

import { AlertProvider } from './context/AlertContext';
import { AlertContainer } from './components/AlertContainer';
import { CampaignListener } from './components/CampaignListener';

function App() {
  return (
    <AuthProvider>
      <AlertProvider>
        <AlertContainer />
        <Router>
          <CampaignListener />
          <div className="min-h-screen bg-tudor-black text-tudor-text font-mono">
            <TudorHeader />
            <main className="bg-black pt-24">
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/link-account" element={<LinkAccount />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/rules" element={<Rulebook />} />
                <Route path="/campaigns" element={<Campaigns />} />
                <Route path="/drafting" element={<Drafting />} />
                <Route path="/war-room" element={<WarRoom />} />
                <Route path="/war-room/:warId" element={<WarRoom />} />
                <Route path="/battle" element={<Battle />} />
                <Route path="/battle/:warId" element={<Battle />} />
                <Route path="/lobby/:warId" element={<Lobby />} />
                <Route path="/court" element={<Court />} />
                <Route path="/quickplay" element={<QuickPlay />} />
                <Route path="/barracks" element={<Barracks />} />
                <Route path="/leaderboard" element={<ComingSoon title="High Council" />} />
                <Route path="/account" element={<ComingSoon title="Royal Treasury" />} />
                <Route path="/history" element={<History />} />
                <Route path="/replay/:battleId" element={<ReplayBattle />} />
                <Route path="/simulation" element={<WarSimulation />} />
                {/* Catch-all for Supabase Auth Redirects or 404s */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
          </div>
        </Router>
      </AlertProvider>
    </AuthProvider>
  );
}

export default App;
